var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 50,
    fill: "#FFF6E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8116 73.3011L58.2658 38.3049C58.4849 37.9099 58.808 37.5804 59.2011 37.3508C59.5942 37.1212 60.0429 37 60.5 37C60.9571 37 61.4058 37.1212 61.7989 37.3508C62.192 37.5804 62.5151 37.9099 62.7342 38.3049L82.1884 73.3011C82.4002 73.6822 82.5075 74.1111 82.4996 74.5454C82.4917 74.9798 82.3689 75.4046 82.1434 75.7781C81.9178 76.1515 81.5973 76.4605 81.2134 76.6748C80.8295 76.8891 80.3955 77.0012 79.9542 77H41.0458C40.6045 77.0012 40.1705 76.8891 39.7866 76.6748C39.4027 76.4605 39.0822 76.1515 38.8566 75.7781C38.6311 75.4046 38.5083 74.9798 38.5004 74.5454C38.4925 74.1111 38.5998 73.6822 38.8116 73.3011ZM63.2081 60.3316L64.5723 52.274C64.6126 52.0354 64.5996 51.7911 64.5343 51.5579C64.469 51.3248 64.3529 51.1084 64.1941 50.9238C64.0353 50.7393 63.8376 50.591 63.6147 50.4892C63.3918 50.3875 63.1491 50.3347 62.9034 50.3346H58.0966C57.8509 50.3347 57.6082 50.3875 57.3853 50.4892C57.1624 50.591 56.9647 50.7393 56.8059 50.9238C56.6471 51.1084 56.531 51.3248 56.4657 51.5579C56.4004 51.7911 56.3874 52.0354 56.4277 52.274L57.7919 60.3316H63.2081ZM64.2236 66.6631C64.2236 65.6909 63.8313 64.7586 63.133 64.0711C62.4347 63.3837 61.4876 62.9975 60.5 62.9975C59.5124 62.9975 58.5653 63.3837 57.867 64.0711C57.1687 64.7586 56.7764 65.6909 56.7764 66.6631C56.7764 67.6352 57.1687 68.5676 57.867 69.255C58.5653 69.9425 59.5124 70.3286 60.5 70.3286C61.4876 70.3286 62.4347 69.9425 63.133 69.255C63.8313 68.5676 64.2236 67.6352 64.2236 66.6631Z",
    fill: "#FEB530"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.82cae3e115b9719d85f038f5955ed183.svg";
export { ForwardRef as ReactComponent };